<template>
    <transition name="modal">
      <div v-if="isVisible" class="modal-overlay" @click="closeModal">
        <div class="modal-content" @click.stop>
          <div class="failure-cross">
            <div class="cross-icon">
              <span class="icon-line line-left"></span>
              <span class="icon-line line-right"></span>
              <div class="icon-circle"></div>
            </div>
          </div>
          <h2 class="title">{{ message }}</h2>
          <button class="close-button" @click="closeModal">OK</button>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'FailureModal',
    props: {
      message: {
        type: String,
        default: '操作失败！'
      }
    },
    data() {
      return {
        isVisible: false
      }
    },
    methods: {
      showModal() {
        this.isVisible = true
      },
      closeModal() {
        this.isVisible = false
        this.$emit('close')
      }
    }
  }
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background-color: white;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    width: 350px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  
  .failure-cross {
    width: 80px;
    height: 80px;
    margin: 0 auto 15px;
  }
  
  .cross-icon {
    width: 80px;
    height: 80px;
    position: relative;
    border-radius: 50%;
    box-sizing: content-box;
    border: 4px solid #FF5252;
  }
  
  .icon-line {
    height: 5px;
    background-color: #FF5252;
    display: block;
    border-radius: 2px;
    position: absolute;
    z-index: 10;
    top: 37px;
    left: 19px;
    width: 42px;
  }
  
  .icon-line.line-left {
    transform: rotate(45deg);
    animation: icon-line-left 0.75s;
  }
  
  .icon-line.line-right {
    transform: rotate(-45deg);
    animation: icon-line-right 0.75s;
  }
  
  .icon-circle {
    top: -4px;
    left: -4px;
    z-index: 10;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    position: absolute;
    box-sizing: content-box;
    border: 4px solid rgba(255, 82, 82, .5);
    animation: circle-appear 0.3s ease-in-out;
  }
  
  .title {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px;
    font-weight: 500;
  }
  
  .close-button {
    background-color: #f5f5f5;
    border: none;
    padding: 8px 24px;
    border-radius: 4px;
    color: #333;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .close-button:hover {
    background-color: #ebebeb;
  }
  
  .modal-enter-active, .modal-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
  
  .modal-enter, .modal-leave-to {
    opacity: 0;
    transform: scale(0.9);
  }
  
  @keyframes icon-line-left {
    0% {
      width: 0;
      left: 40px;
    }
    100% {
      width: 42px;
      left: 19px;
    }
  }
  
  @keyframes icon-line-right {
    0% {
      width: 0;
      right: 40px;
    }
    100% {
      width: 42px;
      right: 19px;
    }
  }
  
  @keyframes circle-appear {
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  </style>